module.exports = __webpack_public_path__ + "static/media/logo.51e8341b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo.png
// module id = 675
// module chunks = 0